import { CAMPAIGNS } from "../lib/constants/actions";

export const getCampaigns = (data) => {
    return { type: CAMPAIGNS.GET_CAMPAIGNS, payload: data }
}

export const getCampaignsSuccess = (data) => {
    return { type: CAMPAIGNS.GET_CAMPAIGNS_SUCCESS, payload: data }
}

export const getCampaignsData = (data) => {
    return { type: CAMPAIGNS.GET_CAMPAIGNS_DATA, payload: data }
}

export const getCampaignsDataSuccess = (data) => {
    return { type: CAMPAIGNS.GET_CAMPAIGNS_DATA_SUCCESS, payload: data }
}


export const changeStatus = (data) => {
    return { type: CAMPAIGNS.CHANGE_STATUS, payload: data }
}


export const changeStatusSuccess = (data) => {
    return { type: CAMPAIGNS.CHANGE_STATUS_SUCCESS, payload: data }
}


export const getCampaignCharges = (data) => {
    return { type: CAMPAIGNS.GET_CAMPAIGN_CHARGES, payload: data }
}
export const getCampaignChargesSuccess = (data) => {
    return { type: CAMPAIGNS.GET_CAMPAIGN_CHARGES_SUCCESS, payload: data }
}

export const saveCampaignCharges = (data) => {
    return { type: CAMPAIGNS.SAVE_CAMPAIGN_CHARGES, payload: data }
}
export const saveCampaignChargesSuccess = (data) => {
    return { type: CAMPAIGNS.SAVE_CAMPAIGN_CHARGES_SUCCESS, payload: data }
}



export const getInterest = (data) => {
    return { type: CAMPAIGNS.GET_INTEREST, payload: data }
}
export const getInterestSuccess = (data) => {
    return { type: CAMPAIGNS.GET_INTEREST_SUCCESS, payload: data }
}

export const saveInterest = (data) => {
    return { type: CAMPAIGNS.SAVE_INTEREST, payload: data }
}
export const saveInterestSuccess = (data) => {
    return { type: CAMPAIGNS.SAVE_INTEREST_SUCCESS, payload: data }
}

export const deleteInterest = (data) => {
    return { type: CAMPAIGNS.DELETE_INTEREST, payload: data }
}
export const deleteInterestSuccess = (data) => {
    return { type: CAMPAIGNS.DELETE_INTEREST_SUCCESS, payload: data }
}


export const getTransactionHistory = (data) => {
    return { type: CAMPAIGNS.GET_TRANSACTION_HISTORY, payload: data }
}
export const getTransactionHistorySuccess = (data) => {
    return { type: CAMPAIGNS.GET_TRANSACTION_HISTORY_SUCCESS, payload: data }
}












